import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Container, Divider, Segment, List, Image, Tab, Checkbox, Label, Popup, Icon } from 'semantic-ui-react'
import { Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import moment from 'moment';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: -10px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableHeader = styled(Table.Header)`
&&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
}
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 0px 0px !important;
    margin: 0px 0px 0px 0px !important;
    font-size: .8em;
}
`

class ListMonitorados extends Component {

    constructor(props) {
        moment.locale('pt-br');
        super(props);
      }

    componentDidMount() {

    }

    render() {
        let { dataList, dataQtde, loader 
        } = this.props;

        return (
            <Tab.Pane loading={loader}>
                        <StyledTable celled id="ListFaturadosSemRota" compact='very' size='small'>
                            <StyledTableHeader>
                                <Table.Row>
                                    
                                    <Table.HeaderCell width="0">SKU</Table.HeaderCell>
                                    <Table.HeaderCell width="5">Produto</Table.HeaderCell>
                                    <Table.HeaderCell width="1">Concorrente</Table.HeaderCell>
                                    <Table.HeaderCell width="0">Grupo</Table.HeaderCell>
                                    <Table.HeaderCell width="2">Preço Concorrente</Table.HeaderCell>
                                    <Table.HeaderCell width="2">Preço VCC</Table.HeaderCell>
                                    <Table.HeaderCell width="1">Preço Definido</Table.HeaderCell>
                                    <Table.HeaderCell width="1">PCT Definido</Table.HeaderCell>
                                    <Table.HeaderCell width="1">PCT Anterior</Table.HeaderCell>
                                    <Table.HeaderCell width="1">DT Inclusão</Table.HeaderCell>
                                    <Table.HeaderCell width="2">DT Alteração</Table.HeaderCell>
                                    <Table.HeaderCell width="1"></Table.HeaderCell>
                                    <Table.HeaderCell width="1"></Table.HeaderCell>
                                    
                                </Table.Row>
                            </StyledTableHeader>

                            <StyledTableBody>
                                {dataList.map(data => (
                                    <Table.Row key={data.id}>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{data.codprod}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{data.produto}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{data.concorrente}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{data.grupo}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>R${data.precoconcorrente.toFixed(2)}|M²{(data.precoconcorrente/data.fatorconversao).toFixed(2)}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>R${data.precoecommvcc.toFixed(2)}|M²{(data.precoecommvcc/data.fatorconversao).toFixed(2)}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>R${data.precodefinido.toFixed(2)}|M²{(data.precodefinido/data.fatorconversao).toFixed(2)}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{data.pctdefinido.toFixed(2)}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{data.vlrvendaold.toFixed(2)}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{moment(data.dtinclusao).format('DD/MM/YYYY')}</Table.Cell>
                                        <Table.Cell negative={data.acao==='Diminuir'?true:false}>{(data.dtalteracao===null?"":moment(data.dtalteracao).format('DD/MM/YYYY HH:mm'))}</Table.Cell>
                                        <Table.Cell>
                                            <Icon 
                                            name={(data.acao==='Aumentar'?'arrow up':'arrow down')} 
                                            color={(data.acao==='Aumentar'?'blue':'red')}
                                            />
                                        </Table.Cell>
                                        <Table.Cell negative={data.ad_robopausa===null||data.ad_roboprecos!='S'?false:true}>
                                            <Link to='#' title={'Item monitorado até: '+moment(data.ad_robopausa).format('DD/MM/YYYY HH:mm')}>
                                            <Label horizontal color={data.recorrenciasmanter===0?'red':'orange'} key={data.id}>{data.recorrenciasmanter}</Label>
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                                
                            </StyledTableBody>
                        </StyledTable>
            </Tab.Pane>
        )
    }
}

ListMonitorados.defaultProps = {
    dataList: []
    , loader: true
};

ListMonitorados.propTypes = {
    dataList: PropTypes.array.isRequired
    , loader: PropTypes.bool.isRequired
};



export default ListMonitorados
